import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

class SinglePublicationHeader extends React.Component
{
    determineText()
    {
        const {
            title,
            translateTitle,
        } = this.props;

        if (translateTitle)
        {
            return <FormattedMessage id={title}/>;
        }

        return title;
    }

    renderHrContent()
    {
        const {
            showHr,
            hrStyle,
        } = this.props;

        if (showHr)
        {
            return <hr style={hrStyle || { marginTop: '1rem' }}/>;
        }

        return null;
    }

    render()
    {
        const { imageUrl } = this.props;

        return (
            <div style={{
                height: '60vh',
                position: 'relative',
                background: '#000',
                color: '#FFF',
            }}>
                <img
                    alt="Header Image"
                    src={imageUrl}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: 100,
                        opacity: '.4',
                    }}/>
                <h1
                    style={{
                        zIndex: '200',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }}
                    className="page-header-title-single-publication"
                >
                    {this.determineText()}
                </h1>
            </div>
        );
    }
}

SinglePublicationHeader.propTypes = {
    title: PropTypes.string.isRequired,
    translateTitle: PropTypes.bool,
    showHr: PropTypes.bool,
    hrStyle: PropTypes.object,
    imageUrl: PropTypes.string,
};

export default SinglePublicationHeader;
